@for (item of currentFilters(); track item.label + '_' + item.attribute; let i = $index) {
  @if (shouldShowFilter(i, showAll())) {
    <span (click)="removeRefinement($event, item)">
      {{ getLabel(item.facetLabel, item.label) }}
    </span>
  }
}
@if (shouldShowAllBtn()) {
  <button (click)="toggleShowAll()" class="btn-filter-outlined me-2">
    {{ showAllBtnText() }}
  </button>
}
<app-clear-refinements i18n-resetLabel resetLabel="Ryd filtrering"
  [includedAttributes]="getFilterAttributes()"
                       class="d-inline-block"/>
